import { FormatUtils } from "../utils/_FormatUtils";

const template = `
    <div class="post_wrapper">
        <div class="post_item :classes:">
            <a href=":post_link:" class="post_image_container">
                :post_images:
            </a>
            <span class="post_desc">
                <div class="d-flex align-items-center mb-2">
                    <div class="d-flex align-items-center">
                        <i class="icon pi-date-picker fs-6 ms-1" style="margin-bottom: 1px;"></i>
                        <span class="post_date">:post_date:</span>
                    </div>
                    <div class="d-flex align-items-center me-3">
                        <i class="icon pi-eye fs-6 ms-1" style="margin-bottom: 1px;"></i>
                        <span class="post_view">:post_view_count:</span>
                    </div>
                </div>
                <a href=":post_link:" class="post_title">:post_title:</a>
                <div class="post_summary">
                <span>:post_summary:</span>
                <a href=":post_link:" style="text-decoration: underline;">ادامه‌ی مطلب</a>
                </div>
                <div class="post_cats">
                    :post_categories:
                </div>
            </span>
        </div>
    </div>
`;

/*
 :post_image_url:
:post_date:
:post_title:
:post_summary:
:post_categories:
*/

/**
 * Class to create a blog post
 *
 * @class BlogPost
 */
class BlogPost {
    /**
     * Creates an instance of BlogPost.
     * @param {{
     * id: string,
     * images: {string: any}[],
     * created_at: string,
     * date: string,
     * content: string,
     * title: string,
     * tags: {id: string, name: string, fa_name: string}[],
     * views_number
     * }} post
     * @param {{
     *  horizontal: [boolean],
     *  smallImage: [boolean],
     *  thumb: [boolean],
     * }} options
     * @memberof BlogPost
     */
    constructor(post, options = null) {
        let template_elm = template;
        this.post = post;
        this.options = options;

        template_elm = template_elm.replace(
            /:post_link:/g,
            `/blog/post/${post.id}`
        );

        if (options.thumb) {
            template_elm = template_elm.replace(
                /:post_images:/g,
                `
                <img  class="post_image" src="${
                    "/" + post.images.headers.mobile
                }" alt=":post_title:" />
            `
            );
        } else {
            template_elm = template_elm.replace(
                /:post_images:/g,
                `
                <picture>
                    <source media="(max-width: 767px)" srcset="${
                        "/" + post.images.headers.mobile
                    }" />
                    <source media="(min-width: 768px)" srcset="${
                        "/" + post.images.headers.desktop
                    }" />
                    <img  class="post_image" src="${
                        "/" + post.images.headers.desktop
                    }" alt=":post_title:" />
                </picture>
            `
            );
        }

        template_elm = template_elm.replace(/:post_date:/g, post.date);
        template_elm = template_elm.replace(
            /:post_view_count:/g,
            FormatUtils.number(post.views_number)
        );
        template_elm = template_elm.replace(/:post_title:/g, post.title);
        template_elm = template_elm.replace(
            /:post_summary:/g,
            post.description
        );

        const category_elements = post.tags
            .map((cat) => {
                return `<a href="/blog/cat/${cat.fa_name}" class="category">${cat.fa_name}</a>`;
            })
            .join("");

        template_elm = template_elm.replace(
            /:post_categories:/g,
            category_elements
        );

        if (options) {
            let classes = "";

            if (options.thumb) {
                classes += " thumb";
            }

            template_elm = template_elm.replace(/:classes:/g, classes);
        }

        this.template = template_elm;
    }

    /**
     *
     *
     * @param {string} id
     * @memberof BlogPost
     */
    addTo(id) {
        $("#" + id).append(this.template);
    }

    /**
     * Get created account element
     * @return {string}
     */
    get() {
        return this.template;
    }
}

export { BlogPost };
